import React, { useState, useEffect, useContext } from "react";
import deleteicon from "../../../Assets/Images/DeleteIcon.svg";
import AssessmentScores from "../AssessmentScores";
import notesicon from "../../../Assets/Images/notesIcon.svg";
import Box from "../../../Assets/Images/box (3).png";
import Checkbox from "../../../Assets/Images/checkbox.png";
import { useNavigate, useSearchParams } from "react-router-dom";
import { deleteTeam, deleteAssessment, fetchVariables } from "../../../api";
import { toast } from "react-toastify";
import { Modal, Button } from "@mui/material";
import deleteIcon from "../../../Assets/Images/deleteIcon.png";
import { authenticatedFetch } from "../../../utils/apiUtils";
import GroupReportContext from "../../../Context/GroupReportContext";

export default function Reports({ clientData, clientId, selectedReportParams, setValue, setSelectedReportParams, updateClientData, }) {
  const [resultData, setResultData] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [checkboxStates, setCheckboxStates] = useState(Array(10).fill(false));
  const [assessmentList, setAssessmentList] = useState([]);
  const [activeFilters, setActiveFilters] = useState(["All"]);
  const [memberResults, setMemberResults] = useState({});
  const [isLoadingMemberResults, setIsLoadingMemberResults] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [reportToDelete, setReportToDelete] = useState(null); // { data }
  const [isDeleting, setIsDeleting] = useState(false);
  const [pendingReportView, setPendingReportView] = useState(null);
  const [groupReportPreviewData, setGroupReportPreviewData] = useState([]);
  const groupReportCtx = useContext(GroupReportContext)
  const { openReport, setOpenReport, selectedReport, setSelectedReport, selectedReportType, setSelectedReportType } = groupReportCtx;
  const [groupMembers, setGroupMembers] = useState()
  const assessmentId = searchParams.get("assessmentId")
  const param_reportType = searchParams.get("reportType")

  // Handle filter button click
  const handleFilterClick = (filter) => {
    if (filter === "All") {
      setActiveFilters(["All"]);
    } else {
      setActiveFilters((prev) => {
        if (prev.includes(filter)) {
          return ["All"];
        }
        return [filter];
      });
    }
    setResultData((prev) => [...prev]);
  };

  function mapData(input) {
    let detectedReportType = input.reportType;

    if (!detectedReportType) {
      if (input.designation?.includes("360")) {
        detectedReportType = "360";
      } else if (input.designation?.includes("Group")) {
        detectedReportType = "Group";
      } else if (input.designation?.includes("Self") || input.isSelfReport) {
        detectedReportType = "Self";
      }
    }

    const is360SelfReport = input.designation === "360 Assessment" && (detectedReportType === "Self" || input.isSelfReport);

    return {
      id: input.id,
      name: input.userName || input.name || "Unnamed Report",
      assessment_hash: detectedReportType === "Group" ? input.teamId : input.assessment_hash,
      reportName:
        detectedReportType === "360"
          ? `${input.userName || ""} - 360 Report`
          : `${input.name || "Assessment"} ${
              is360SelfReport ? "Self" : detectedReportType
            }-Assessment`,
      by: `${is360SelfReport ? "Self" : detectedReportType} report`,
      reportType: is360SelfReport ? "Self" : detectedReportType,
      self_hash: input.assessment_hash,
      _originalData: input,
      ...(is360SelfReport && { isSelfReport: true }),
      remark:
        detectedReportType === "360" || detectedReportType === "Group"
          ? [
              detectedReportType === "360" ? "Observers" : "Group Members",
              input?.members?.map((member) => member.userName.trim()).join(", "),
            ]
          : null,
    };
  }

  useEffect(() => {
    const assessmentIdParam = searchParams.get("assessmentId");

    searchParams.set("tab", 2);
    setSearchParams(searchParams);

    if (!assessmentIdParam) {
      setSelectedReportParams({
        assessmentId: null,
        reportType: null,
      });
    }
  }, []); // eslint-disable-line

  // useEffect(() => {
  //   if (selectedReportParams && assessmentList?.length > 0) {
  //     let reportToOpen = assessmentList.find(
  //       (a) => a.assessment_hash === selectedReportParams.assessmentId
  //     );

  //     if (
  //       selectedReportParams.reportType === "Self" &&
  //       reportToOpen?.designation === "360 Assessment"
  //     ) {
  //       reportToOpen = {
  //         ...reportToOpen,
  //         isSelfReport: true,
  //         reportType: "Self",
  //       };
  //     }

  //     if (reportToOpen) {
  //       const mappedReport = mapData(reportToOpen);
  //       setSelectedReport(mappedReport);
  //       setSelectedReportType(mappedReport.reportType);
  //       setOpenReport(false);

  //       const members = clientData.assessments.find(
  //         (a) => a.assessment_hash === selectedReportParams.assessmentId
  //       )?.members;

  //       if ( selectedReportParams.reportType === "360" && members && members.length > 0 ) {
  //         fetch360MemberResults(selectedReportParams.assessmentId, members);
  //       } else {
  //         setMemberResults({});
  //       }

  //       const searchParams = new URLSearchParams(window.location.search);
  //       searchParams.set("tab", "reports");
  //       searchParams.set("assessmentId", selectedReportParams.assessmentId);
  //       searchParams.set("reportType", mappedReport.reportType);
  //       const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
  //       window.history.replaceState(null, "", newUrl);
  //     }
  //   }
  // }, [selectedReportParams, assessmentList]); 

  useEffect(() => {
    const selectedReportValue = groupReportCtx?.selectedReport?.value?.split("-");
    const selectedAsmtId = selectedReportValue?.[0];
    const selectedReportOption = selectedReportValue?.[1];
    const selectedReportPreview = resultData?.find( (el) => el?.id === selectedAsmtId && el?.reportType === selectedReportOption );
    const memberResults = Object.fromEntries(
      selectedReportPreview?._originalData?.results?.map((el) => [
        el?.hash,
        el,
      ]) ?? []
    );

    setMemberResults(memberResults);
  }, [groupReportCtx?.selectedReport]);

  useEffect(() => {
    if (groupReportPreviewData?.length > 0) {
      setResultData((prevData) => {
        const filteredData = prevData.filter(
          (item) => !groupReportPreviewData.some((gr) => gr.id === item.id)
        );
        return [...groupReportPreviewData, ...filteredData];
      });
    }
  }, [groupReportPreviewData]);

  useEffect(() => {
    if (groupReportPreviewData && groupReportPreviewData.length > 0) {
      setResultData(groupReportPreviewData);
    } else {
      setResultData([]);
    }
  }, [groupReportPreviewData]);

  useEffect(() => {
    const handleStorageChange = () => {
      try {
        const storedClientData = localStorage.getItem("clientData");
        if (storedClientData) {
          const parsedClientData = JSON.parse(storedClientData);
          if (parsedClientData?.assessments?.length > 0) {
            setAssessmentList(parsedClientData.assessments);
          }
        }
      } catch (error) {
        console.error("Error parsing client data from localStorage:", error);
      }
    };

    const handleGroupReportPreviewDataChange = () => {
      loadGroupReportPreviewData();
    };

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("storage", handleGroupReportPreviewDataChange);
    window.addEventListener("clientDataUpdated", handleStorageChange);
    window.addEventListener(
      "groupReportPreviewDataUpdated",
      handleGroupReportPreviewDataChange
    );

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("storage", handleGroupReportPreviewDataChange);
      window.removeEventListener("clientDataUpdated", handleStorageChange);
      window.removeEventListener(
        "groupReportPreviewDataUpdated",
        handleGroupReportPreviewDataChange
      );
    };
  }, []);

  // useEffect(() => {
  //   if (pendingReportView && resultData.length > 0) {
  //     setSelectedReport(pendingReportView);
  //     setSelectedReportType(pendingReportView.reportType);
  //     setOpenReport(false);
  //     setPendingReportView(null);
  //   }
  // }, [pendingReportView, resultData]);

  /**
   * Fetches assessment results for all members of a 360 assessment
   * @param {string} assessmentId - The main 360 assessment ID
   * @param {Array} members - Array of member objects with assessment_hash
   * @returns {Object} - Object containing results for each member keyed by assessment_hash
   */
  const fetch360MemberResults = async (assessmentId, members) => {
    setIsLoadingMemberResults(true);
    try {
      const fetchPromises = members.map((member) =>
        fetch(
          `${process.env.REACT_APP_API_URI}/v3/user/assessment/${member.assessment_hash}/results`,
          {
            method: "GET",
            mode: "cors",
            headers: { "Content-Type": "application/json" },
          }
        )
          .then((response) => response.json())
          .then((data) => ({
            assessment_hash: member.assessment_hash,
            userName: member.userName,
            designation: member.designation,
            data: data.status === "success" ? data : null,
          }))
          .catch((error) => {
            console.error(
              `Error fetching results for member ${member.userName}:`,
              error
            );
            return {
              assessment_hash: member.assessment_hash,
              userName: member.userName,
              designation: member.designation,
              data: null,
            };
          })
      );

      const results = await Promise.all(fetchPromises);

      const memberResultsObj = results.reduce((acc, result) => {
        if (result.data) {
          acc[result.assessment_hash] = {
            ...result.data,
            userName: result.userName,
            designation: result.designation,
          };
        }
        return acc;
      }, {});

      setMemberResults(memberResultsObj);
      return memberResultsObj;
    } catch (error) {
      console.error("Error fetching 360 member results:", error);
      setMemberResults({});
      return {};
    } finally {
      setIsLoadingMemberResults(false);
    }
  };

  const fetchGroupReportPreviewData = async () => {
    if (!clientId) {
      return;
    }

    try {
      const response = await authenticatedFetch(
        `${process.env.REACT_APP_API_URI}/v5/organisations/tl/preview/${clientId}`,
        {
          method: "GET",
          mode: "cors",
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.status == "success") {
        const previewData = await response;
        localStorage.setItem(
          "groupReportPreviewData",
          JSON.stringify(previewData)
        );
        loadGroupReportPreviewData();
      } else {
        console.error("Preview API failed with status:", response.status);
      }
    } catch (error) {
      console.error("Error calling preview API:", error);
    }
  };

  const handleReportDetail = (id) => {
    if (selectedMembers.includes(id)) {
      setSelectedMembers(selectedMembers.filter((memberId) => memberId !== id));
    } else {
      setSelectedMembers([id, ...selectedMembers]);
    }
  };

  const handleBoxClick = (index) => {
    const updatedStates = [...checkboxStates];
    updatedStates[index] = !updatedStates[index];
    setCheckboxStates(updatedStates);
  };

  // -------- FIX #1 & #2: pass the whole report and store it -------------
  const handleDeleteItem = (report) => {
    setReportToDelete({ data: report });
    setOpenDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (!reportToDelete) {
      return;
    }

    setIsDeleting(true);
    try {
      const response = await deleteTeam(reportToDelete.data.assessment_hash);

      if (response.status === "success") {
        setResultData((prevResultData) =>
          prevResultData.filter(
            (item) => !( item.id === reportToDelete.data.id && item.reportType === reportToDelete.data.reportType )
          )
        );

        const updatedGroupReports = groupReportPreviewData.filter(
          (report) => report.id !== reportToDelete.data.id
        );
        setGroupReportPreviewData(updatedGroupReports);

        const currentPreviewData = JSON.parse(
          localStorage.getItem("groupReportPreviewData") || "{}"
        );

        if ( currentPreviewData && currentPreviewData.data && Array.isArray(currentPreviewData.data) ) {
          const updatedData = {
            ...currentPreviewData,
            data: currentPreviewData.data.filter(
              (item) => item.hash !== reportToDelete.data.id && item.teamId !== reportToDelete.data.assessment_hash ),
          };
          localStorage.setItem(
            "groupReportPreviewData",
            JSON.stringify(updatedData)
          );
        }

        window.dispatchEvent(new Event("groupReportPreviewDataUpdated"));

        const reportType = reportToDelete.data.reportType;
        let successMessage = "";

        if (reportType === "Self") {
          successMessage = "Self report deleted successfully";
        } else if (reportType === "360") {
          successMessage = "360 report deleted successfully";
        } else if (reportType === "Group") {
          successMessage = "Group report deleted successfully";
        } else {
          successMessage = "Report deleted successfully";
        }

        toast.success(successMessage);
      } else {
        throw new Error("Failed to delete report");
      }
    } catch (error) {
      console.error("Error deleting report:", error);
      toast.error("Failed to delete report. Please try again.");
    } finally {
      setIsDeleting(false);
      setOpenDeleteModal(false);
      setReportToDelete(null);
    }
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
    setReportToDelete(null);
  };

  const handleViewReport = async (report) => {
    groupReportCtx?.setSelectedReport({
      label: report?.reportName,
      reportType: report?.reportType,
      value: `${report?.id}-${report?.reportType}`,
      teamId: report?._originalData?.teamId,
    });

    let fetchedVariables = await fetchVariables(report?._originalData?.teamId);

    // I need hashmap here
    const hashMap = {};
    fetchedVariables?.results?.map((el) => {
      hashMap[el?.hash] = el?.variables;
      return null;
    });

    const selectedAsmtId = report?.id;
    const selectedReportOption = report?.reportType;
    const selectedReportPreview = resultData?.find( (el) => el?.id === selectedAsmtId && el?.reportType === selectedReportOption );
    const memberResults = Object.fromEntries(
      selectedReportPreview?._originalData?.results?.map((el) => [
        el?.hash,
        {
          ...el,
          variables: hashMap[el?.hash],
        },
      ]) ?? []
    );

    setMemberResults(memberResults);
    setGroupMembers(hashMap);
    groupReportCtx?.setGroupMembersHashMap({
      teamId: report?._originalData?.teamId,
      hashMap,
    });

    const searchParams = new URLSearchParams();
    searchParams.set("tab", "reports");
    searchParams.set("assessmentId", report.assessment_hash);
    searchParams.set(
      "reportType",
      report.reportType?.includes("360")
        ? "360"
        : report.reportType?.includes("Group")
        ? "Group"
        : "Self"
    );

    if (resultData.length === 0) {
      setPendingReportView(report);
      let sourceList =
        assessmentList?.length > 0
          ? assessmentList
          : clientData?.assessments || [];
      if (sourceList.length > 0) {
        let resultFormatData = sourceList.filter((a) => a.status === "complete");
        resultFormatData = resultFormatData.map((m) => mapData(m));
        const updatedResultData = [
          ...(groupReportPreviewData || []),
          ...resultFormatData,
        ];
        setResultData(updatedResultData);
      }
    } 
    else {
      const tempReport = {
        ...report,
        teamId: report?._originalData?.teamId,
      };
      setSelectedReport(tempReport);
      setSelectedReportType(report.reportType);
      setOpenReport(false);
    }

    // For 360 reports, fetch member results
    if (report.reportType?.includes("360")) {
      const members = clientData.assessments.find(
        (a) => a.assessment_hash === report.assessment_hash
      )?.members;
      if (members && members.length > 0) {
        fetch360MemberResults(report.assessment_hash, members);
      }
    } else {
      // Clear member results for non-360 reports
      setMemberResults({});
    }
  };

  const handleBackToReports = () => {
    setOpenReport(true);
    setSelectedReport(null);
    setSelectedReportType(null);
  };

  const filterReports = (reports) => {
    if (!reports || reports.length === 0) return [];
    let filteredReports = reports.filter((report) => {
    
      if (!report || !report.reportType) return false;

      if (report.reportType === "360" && !report.id) return false;

      return true;
    });

    // If no filters or 'All' is selected, return all valid reports
    if (activeFilters.length === 0 || activeFilters.includes("All")) {
      return filteredReports;
    }

    // Apply the active filter
    const filter = activeFilters[0];

    const filtered = filteredReports.filter((report) => {
      // First check the reportType
      if (filter === "Self" && report.reportType === "Self") return true;
      if (filter === "360" && report.reportType === "360") return true;
      if (filter === "Group" && report.reportType === "Group") return true;

      // Fallback to checking the 'by' field if reportType doesn't match
      if (filter === "Self") return report.by?.toLowerCase().includes("self");
      if (filter === "360") return report.by?.toLowerCase().includes("360");
      if (filter === "Group") return report.by?.toLowerCase().includes("group");

      return false;
    });

    return filtered;
  };

  // Function to load and format group report preview data from localStorage
  const loadGroupReportPreviewData = () => {
    try {
      const storedData = localStorage.getItem("groupReportPreviewData");

      // Also check if we have stored groupReports with assessment_hash
      const groupReports = localStorage.getItem("groupReports");

      if (storedData && storedData !== "undefined" && storedData !== "null") {
        const parsedData = JSON.parse(storedData);

        // Format the data according to the specified structure
        if (parsedData?.data && Array.isArray(parsedData.data)) {
          const formattedData = parsedData.data.map(mapPreviewData);
          setGroupReportPreviewData(formattedData);
        } else {
          setGroupReportPreviewData([]);
        }
      } else {
        setGroupReportPreviewData([]);
      }
    } catch (error) {
      setGroupReportPreviewData([]);
    }
  };

  function mapPreviewData(data) {
    const memberNames = [];
    if (data.results && typeof data.results === "object") {
      Object.values(data.results).forEach((result) => {
        if (result.fullName) {
          memberNames.push(result.fullName.trim());
        }
      });
    }

    let assessmentHash = data.hash || data.id || data.assessment_hash;

    if (!assessmentHash) {
      // Create a unique identifier using teamname and a simple hash
      const teamname = data.teamname || "Unknown";
      // Create a simple hash from teamname and member count for uniqueness
      const memberCount = memberNames.length;
      const simpleHash =
        teamname.toLowerCase().replace(/[^a-z0-9]/g, "") + memberCount;
      assessmentHash = simpleHash;
    }

    const capitalize = (str) => {
      if (!str) return "";
      return str[0].toUpperCase() + str.slice(1);
    };

    const reportName = {
      360: "360 Report",
      group: "Group report",
    };

    let self_hash_arr = groupReportCtx?.selectedAsmtList
      ?.filter((el) => el?.designation === "360 Assessment")
      ?.map((el) => el?.assessment_hash);

    let self_hash;
    if (data?.type === "360") {
      const match = data?.results?.find((el) => self_hash_arr?.includes(el?.hash));
      self_hash = match?.hash;
    }

    const mappedData = {
      id: assessmentHash,
      name: data.teamname || "Unknown Team",
      teamName: data.teamname || "Unknown Team",
      assessment_hash: data.teamId,
      reportName: `${data.teamname || "Unknown Team"} ${data.type === "360" ? "- 360 Report" : "Group-Assessment"}`,
      by: reportName[data.type],
      reportType: capitalize(data.type),
      self_hash: self_hash,
      remark:
        memberNames.length > 0
          ? [`${capitalize(data.type) === "360" ? "360 Members" : "Group Members"}`, memberNames.join(", ")]
          : null,
      // Store original data for debugging
      _originalData: data,
    };

    return mappedData;
  }

  useEffect(() => {
    fetchGroupReportPreviewData();
  }, [clientId, selectedReport, assessmentId, param_reportType]); // eslint-disable-line

  // Load preview data when component mounts
  useEffect(() => {
    loadGroupReportPreviewData();
  }, []);

  const getReportTypeText = (reportType) => {
    switch (reportType) {
      case "Self":
        return "Self";
      case "360":
        return "360";
      case "Group":
        return "Group";
      default:
        return "Team";
    }
  };

  // Ensure this return is inside the Reports function component
  return (
    <div className="container-report">
      {openReport ? (
        <>
          {" "}
          <div className="filter-buttons">
            {["All", "Self", "360", "Group"].map((filter, idx) => {
              const isActive = activeFilters.includes(filter);
              const showClose =
                (filter === "All" && activeFilters.includes("All")) ||
                (filter !== "All" && isActive);

              return (
                <button
                  key={filter}
                  className={`filter-btn ${isActive ? "active" : ""}`}
                  onClick={() => handleFilterClick(filter)}
                >
                  {filter}
                  {showClose && (
                    <span
                      className="filter-remove"
                      onClick={(e) => {
                        e.stopPropagation();
                        setActiveFilters((prev) =>
                          filter === "All" ? [] : prev.filter((f) => f !== filter)
                        );
                      }}
                    >
                      ×
                    </span>
                  )}
                </button>
              );
            })}
          </div>
          {resultData.length > 0 ? (
            filterReports(resultData).map((data, index) => {
              return (
                <div className="report" key={index}>
                  <div className="left">
                    <div
                      className="checkbox-box-wrapper"
                      onClick={() => handleBoxClick(index)}
                    >
                      <img
                        src={checkboxStates[index] ? Checkbox : Box}
                        alt={
                          checkboxStates[index]
                            ? "Checked Checkbox"
                            : "Empty Box"
                        }
                        height={40}
                        width={40}
                      />
                    </div>
                    <img
                      src={notesicon}
                      alt="Notes Icon"
                      className="notesicon"
                    />
                    <div>
                      <p className="name capitalize">
                        {data?.teamName && data?.teamName !== ""
                          ? data?.teamName
                          : data?.name}{" "}
                        {data?.reportType === "360" ? "- 360 Report" : data?.reportType === "Self" ? "- Self Report" : `- ${data?.by}`}
                      </p>
                      {data.reportType !== "Self" && data.remark && data.remark.length > 1 ? (
                        <p className="subdetail">
                          {data.remark[0]}: <span>{data.remark[1]}</span>
                        </p>
                      ) : null}
                    </div>
                  </div>
                  <div className="right">
                    <button
                      className="cta-report"
                      onClick={() => handleViewReport(data)}
                    >
                      View Report
                    </button>
                    {/* FIX #1: pass full data object */}
                    <img
                      src={deleteicon}
                      alt="Delete Icon"
                      onClick={() => handleDeleteItem(data)}
                    />
                  </div>
                </div>
              );
            })
          ) : (
            <div className="no-reports-con">
              <p>
                No reports available yet.<br></br>The client must complete an
                assessment to generate insights.
              </p>
            </div>
          )}
        </>
      ) : (
        <AssessmentScores reportData={selectedReport} reportType={selectedReportType} onBackToReports={handleBackToReports} resultData={resultData} memberResults={memberResults} isLoadingMemberResults={isLoadingMemberResults} groupMembers={groupMembers}  />
      )}

      {/* Delete Confirmation Modal */}
      <Modal
        open={openDeleteModal}
        onClose={handleCloseDeleteModal}
        className="custom-modal"
      >
        <div className="modal-content">
          <div>
            <img src={deleteIcon} alt="delete icon" className="modal-icon" />
            <p className="modal-text">
              Are you sure you want to permanently <br></br> delete this{" "} {reportToDelete && getReportTypeText(reportToDelete.data.reportType)}{" "} Report?
            </p>
            <div className="modal-actions">
              <Button variant="contained" className="modal-button cancel-button" onClick={handleCloseDeleteModal} disabled={isDeleting} >
                No, Cancel
              </Button>
              <Button variant="outlined" className="modal-button delete-button" onClick={handleConfirmDelete} disabled={isDeleting} >
                {isDeleting ? "Deleting..." : "Yes, Delete"}
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
